import constants from "./content/constants.json"

export const AUTO = "z"
export const MIN_LAYERS = 10
export const MAX_LAYERS = constants.MAX_LAYERS || 50

export const Z_STEP_SIZE = constants.Z_STEP_SIZE || 30

// export const SPEED = 250
export const SPEED = constants.SPEED || 250

export const MIN_X = constants.MIN_X || -2 * 100
export const MAX_X = constants.MAX_X || 2 * 100
export const MIN_Y = constants.MIN_Y || -1 * 100
export const MAX_Y = constants.MAX_Y || 0.125 * 100
export const MIN_Z = -10
export const MAX_Z = 0
export const MIN_WIDTH = 50
export const MAX_WIDTH = 50
export const MIN_HEIGHT = 50
export const MAX_HEIGHT = 50
export const MIN_ROTATION = 0
export const MAX_ROTATION = 360
export const MIN_SCALE = constants.MIN_SCALE || 0.5 * 100
export const MAX_SCALE = constants.MAX_SCALE || 2 * 100
export const MIN_HUE = 0
export const MAX_HUE = 0

export const AMBIENT_VOLUME = 0.3
export const ACCENT_VOLUME = 0.75
